import { useCallback } from 'react'
import { useAppDispatch } from '@/state'
import { FormStatusType } from '@/enums/form-status.enum'

import { setFormModeAction } from '@/state/ui/global/slices/index.slices'
import {
  CreateUserPayload,
  DeleteUserPayload,
  GetUsersPayload,
  UpdateUserPayload,
  User,
  UserFilters,
} from '@/state/user/models'
import {
  setCurrentUser,
  setUserFiltersAction,
} from '@/state/user/slices/index.slices'

import createUserThunk from '@/state/user/thunks/create.thunk'
import { deleteUserThunk } from '@/state/user/thunks/delete.thunk'
import { getAllUsersThunk } from '@/state/user/thunks/get-all.thunk'

import { updateUserThunk } from '@/state/user/thunks/update.thunk'

export const useUsersActions = () => {
  const dispatch = useAppDispatch()

  const getAllUsers = useCallback(
    (payload: GetUsersPayload) => {
      dispatch(
        getAllUsersThunk({
          ...payload,
        }),
      )
    },
    [dispatch], // eslint-disable-line
  )

  const createUser = useCallback(
    (payload: CreateUserPayload) => dispatch(createUserThunk(payload)),
    [dispatch],
  )

  const updateUser = useCallback(
    (payload: UpdateUserPayload) => dispatch(updateUserThunk(payload)),
    [dispatch],
  )

  const deleteUser = useCallback(
    (payload: DeleteUserPayload) => dispatch(deleteUserThunk(payload)),
    [dispatch],
  )

  const setFormMode = useCallback(
    (formMode: FormStatusType) => dispatch(setFormModeAction(formMode)),
    [dispatch],
  )

  const setUserFilters = useCallback(
    (filters: UserFilters) => dispatch(setUserFiltersAction(filters)),
    [dispatch],
  )

  const setCurrentUserAction = (payload: User | null) => {
    dispatch(setCurrentUser(payload))
  }

  return {
    createUser,
    deleteUser,
    getAllUsers,
    updateUser,
    setFormMode,
    setUserFilters,
    setCurrentUserAction,
  }
}
